import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LoggerService } from '../logger/logger-service/logger.service';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class BaseApiService {
    protected http: HttpClient = inject(HttpClient);
    protected logger: LoggerService = inject(LoggerService);

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };

    protected readonly apiUrl: string = environment.apiUrl;
}
